<div class="visualisation-container" [ngStyle]="{'width.px': width, 'height.px': height}" #visualisationContainer></div>
